var _path, _path2, _rect, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _circle2, _rect2, _path9, _path10, _circle3, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon, _path19, _path20, _polygon2, _path21, _polygon3, _circle4, _path22, _path23, _path24, _path25, _rect3, _path26, _path27, _circle5, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageFallback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7f7d68b-2588-4b60-b05b-c60a9ab492d2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 923.22156,
    height: 462.14386,
    viewBox: "0 0 923.22156 462.14386",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M382.7367,439.41174h-1.72217V392.23355a27.30544,27.30544,0,0,0-27.30542-27.30548H253.75567a27.30545,27.30545,0,0,0-27.3055,27.30539V651.05677a27.30545,27.30545,0,0,0,27.30542,27.30548H353.709a27.30547,27.30547,0,0,0,27.30554-27.30538V472.994h1.72219Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.81079,372.032H341.76356a9.68791,9.68791,0,0,1-8.96968,13.34677h-57.262a9.6879,9.6879,0,0,1-8.96968-13.34679H254.376a20.39141,20.39141,0,0,0-20.39143,20.39138V650.8669a20.39141,20.39141,0,0,0,20.3914,20.39143H354.81079a20.39141,20.39141,0,0,0,20.39142-20.3914h0V392.42339A20.39139,20.39139,0,0,0,354.81079,372.032Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 123.22973,
    y: 261.81173,
    width: 90.39589,
    height: 60.9854,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.32655,542.03691H261.30724V480.42807h91.01931Zm-90.39589-.62342h89.77247v-60.362H261.93066Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M269.258,528.35679h75.11771v-42.7789H269.258Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 152.96676,
    cy: 285.7186,
    r: 7.52875,
    fill: "#002b44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.9653,527.84752H278.0315a.75178.75178,0,0,1-.138-.01094l17.468-30.25706a1.22306,1.22306,0,0,1,2.129,0l11.7232,20.30484.56163.97159Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "176.576 308.92 163.966 308.92 170.156 299.928 170.602 299.28 170.825 298.956 171.386 299.928 176.576 308.92",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M335.52977,527.84752h-31.9447l6.19025-8.99158.44548-.64774,8.06645-11.71773a1.63221,1.63221,0,0,1,2.42281-.14485,1.458,1.458,0,0,1,.11616.14485Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M571.28048,678.59622H328.99736a21.6844,21.6844,0,0,1-21.6599-21.6599V305.5713a21.68439,21.68439,0,0,1,21.6599-21.6599H571.28048a21.68439,21.68439,0,0,1,21.6599,21.6599v351.365A21.6844,21.6844,0,0,1,571.28048,678.59622Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e5e5e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M571.70694,664.77672H328.5709a6.68454,6.68454,0,0,1-6.67691-6.6769V304.4078a6.68454,6.68454,0,0,1,6.67691-6.6769h243.136a6.68454,6.68454,0,0,1,6.67691,6.6769v353.692A6.68454,6.68454,0,0,1,571.70694,664.77672Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310.8284,
    cy: 71.61669,
    r: 1.8426,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 221.77672,
    y: 179.77373,
    width: 191.3019,
    height: 129.06142,
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M552.1275,528.42288H359.50628V398.0421H552.1275Zm-191.3019-1.31932H550.80818V399.36142H360.8256Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M376.3323,499.4721H535.30149V408.94049H376.3323Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.70824,
    cy: 230.36707,
    r: 15.93285,
    fill: "#002b44"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M473.06109,498.39434H394.89931a1.59155,1.59155,0,0,1-.29207-.02316l36.96693-64.032a2.58832,2.58832,0,0,1,4.50556,0l24.80943,42.97047,1.18856,2.05615Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "334.672 279.466 307.986 279.466 321.086 260.438 322.029 259.067 322.5 258.382 323.688 260.438 334.672 279.466",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M516.581,498.39434H448.97749l13.10023-19.02859.94275-1.37078,17.07078-24.79786a3.45417,3.45417,0,0,1,5.1273-.30654,3.083,3.083,0,0,1,.24583.30654Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M811.82416,674.42384l-12.26392-5.1639-8.413-61.47917H679.113l-9.11906,61.228-10.972,5.48593a2.60549,2.60549,0,0,0,1.16533,4.93586H810.8134A2.60536,2.60536,0,0,0,811.82416,674.42384Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e6e6e6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.91662,615.96031H460.57355A10.90338,10.90338,0,0,1,449.69467,605.057V527.45143h572.10082V605.057A10.90347,10.90347,0,0,1,1010.91662,615.96031Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.37078,564.1297H449.19235v-332.058a13.15889,13.15889,0,0,1,13.14414-13.14367h546.89a13.159,13.159,0,0,1,13.1443,13.14367Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e5e5e5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M988.1371,540.0289H483.426A10.14428,10.14428,0,0,1,473.29284,529.896V253.16175a10.14482,10.14482,0,0,1,10.13319-10.1335H988.1371a10.14482,10.14482,0,0,1,10.13319,10.1335V529.896A10.14428,10.14428,0,0,1,988.1371,540.0289Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.32806,681.07192l-920.60416,0a1.31681,1.31681,0,0,1-1.2935-.95275,1.28512,1.28512,0,0,1,1.24154-1.61274l920.551,0a1.3576,1.3576,0,0,1,1.35829,1.00322A1.28435,1.28435,0,0,1,1060.32806,681.07192Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M855.6778,341.03063c2.59082-8.25684,8.48242-15.82972,16.63037-18.621,8.14844-2.79126,22.36279-.18213,26.20557,7.5658,5.5376,11.1665,3.0498,24.84131.11328,36.96551-1.53125-.08105-3.07666-.14477-4.62647-.20281l-2.19238-7.30713v7.2351c-12.09668-.37384-24.69043-.13977-37.291.1023C853.38776,358.18486,853.087,349.28746,855.6778,341.03063Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#2f2e41"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "828.442 436.728 818.266 440.992 796.975 403.772 811.994 397.478 828.442 436.728",
    fill: "#9f616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M973.56078,664.43194l-32.81125,13.75069-.17394-.415a13.848,13.848,0,0,1,7.41832-18.12328l.00081-.00034,20.04-8.39839Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M817.60413,479.8357a7.6336,7.6336,0,0,1,3.097-11.288l21.87141-65.99735,14.6476,7.81236-26.10475,62.41668a7.675,7.675,0,0,1-13.5113,7.05636Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#9f616a"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "706.181 448.559 695.148 448.559 689.899 406.002 706.183 406.002 706.181 448.559",
    fill: "#9f616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M847.38428,678.18263l-35.57611-.00132v-.45a13.84795,13.84795,0,0,1,13.84722-13.847h.00087l21.72868.00087Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "750.419 206.503 752.919 213.003 752.419 219.503 704.419 213.503 705.919 208.003 711.419 201.503 750.419 206.503",
    fill: "#9f616a"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 734.9489,
    cy: 130.53453,
    r: 17.47509,
    fill: "#9f616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M854.80817,379.431l10-6,20-2,17.67717,4-.17717,32.5-11,24-47-5-2-6.53937s-13-17.46063,1-27.46063Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#002b44"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M857.30817,380.931l-2.5-1.5s-13.5,2.5-16.5,10.5-6,44-6,44l12.5,1.48425,4.5-29.48425Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#002b44"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M891.30817,435.931v11.1063s13,16.8937,6,29.8937c0,0,15,28,16,38l14,46s35,35,32,60l2,8-23,10-5-7-39-67-33-61-6,72s4,56-7,62l-1,9H823.96565V638.3759s-8.65748-30.44488-3.65748-53.44488l-2-97s9-41,20-48l4-10Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M861.33063,326.707a21.94924,21.94924,0,0,1,33.37061,19.15588c-9.76807.44922-20.0293.56616-30.43408.58636l-2.459-6.01818-1.44971,6.02264q-4.75562-.00045-9.52929-.01251A22.41133,22.41133,0,0,1,861.33063,326.707Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 614.15366,
    y: 356.2255,
    width: 242.74912,
    height: 163.77018,
    transform: "translate(-223.67702 -24.1356) rotate(-14.26812)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M874.35767,488.16078,637.47413,548.40127,596.69876,388.06036l236.88353-60.24049ZM638.684,546.36617l233.63855-59.41528L832.37241,329.855,598.73386,389.27024Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M649.11251,507.53571l195.49861-49.71612L816.29821,346.48478,620.79959,396.20091Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.54221,
    cy: 212.2752,
    r: 20.21771,
    fill: "#002b44"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M767.73149,475.95927,671.609,500.40364a2.01923,2.01923,0,0,1-.36643.06287l25.43612-90.307a3.28441,3.28441,0,0,1,5.54089-1.40907l43.949,45.08571,2.10472,2.15692Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "629.342 257.031 596.524 265.377 606.683 237.879 607.414 235.899 607.78 234.908 609.884 237.065 629.342 257.031",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M821.25183,462.34882l-83.1381,21.14238,10.15951-27.49814.73068-1.9806,13.23817-35.83487a4.38312,4.38312,0,0,1,6.20964-1.9805,3.91288,3.91288,0,0,1,.39818.3001Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M874.68524,458.89405a7.8608,7.8608,0,0,1,1.1826.36556l30.50721-20.9993-.69808-8.97026,13.4-2.82293,2.77908,15.76a5.97435,5.97435,0,0,1-3.241,6.39566L880.82549,467.2597a7.83917,7.83917,0,1,1-6.14025-8.36565Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#9f616a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M895.30817,376.931l7.17717-1.5s15.82283-5.5,16.82283,14.5l2,47-14.85433,2-6.14567-41Z",
    transform: "translate(-138.38922 -218.92807)",
    fill: "#002b44"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFallback);
export default __webpack_public_path__ + "static/media/imageFallback.74a039fed3e25157494dbb0a554bb60a.svg";
export { ForwardRef as ReactComponent };